"use client";

import { LuEllipsis as LuMoreHorizontal } from "react-icons/lu";

import { setDialog } from "@/components/app/dialogs/dialog-provider";
import { Button } from "@/components/ui/button";
import { DIALOG } from "@/utils/dialog-routes";

type CollectionListItemManageButtonProps = {
  collectionId: string;
};

export const CollectionListItemManageButton = ({
  collectionId,
}: CollectionListItemManageButtonProps) => {
  return (
    <Button
      variant="outline"
      size="icon"
      onClick={() => {
        setDialog(DIALOG.CreateCollection, {
          open: true,
          params: {
            collectionId,
          },
        });
      }}
    >
      <LuMoreHorizontal className="size-4" />
      <span className="sr-only">Manage collection</span>
    </Button>
  );
};
